import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';
import { ApolloQueryResult } from '@apollo/client/core';
import { Observable, throwError } from 'rxjs';
import { AuthorizedJurisdictionsService } from '../services/authorized-jurisdictions/authorized-jurisdictions.service';
import { AuthorizedJurisdictionInfoQueryVars } from '../master-wage-data/interfaces/authorized-jurisdiction-info-query-vars.interface';
import { LCPUserService } from '@shared/services/lcp-user/lcp-user.service';

export const authorizedJurisdictionResolver: ResolveFn<Observable<ApolloQueryResult<unknown>>> = (route, state) => {

  // Dependency Injection
  const authorizedJurisdictionsService = inject(AuthorizedJurisdictionsService);
  const _lcpUserService = inject(LCPUserService);

  // Extract variables
  const jurisdictionId: string | null = route.paramMap.get('jurisdictionId');
  const sessionTenantId: string = _lcpUserService.getUserTenantIdValue();

  // Validate incoming variables
  if (!jurisdictionId) {
    return throwError(
      () => new Error('No Wage Determination Modification Id was provided. Please Contact Support.')
    );
  }

  const queryVars: AuthorizedJurisdictionInfoQueryVars = {
    skip: 0,
    take: 10,
    tenantId: sessionTenantId,
    where: {
      authorizedTenantId:  {
        eq: sessionTenantId
      },
      jurisdictionId: {
        eq: jurisdictionId
      }
    }
  }

  return authorizedJurisdictionsService.getAuthorizedJurisdictionInfoQuery(queryVars);
};
